import { Component, signal, computed, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme.service';
import { ZoomService } from './core/services/zoom.service';
import { CommonModule } from '@angular/common';
import { Toast } from 'primeng/toast';
import { ConnectivityBannerComponent } from './core/components/connectivity-banner/connectivity-banner.component';
import { InactivityTimerService } from './core/services/inactivity-timer.service';
import { AuthStateService } from './core/services/auth-state.service';
import { InactivityTimerDialogComponent } from './shared/components';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, Toast, ConnectivityBannerComponent, InactivityTimerDialogComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {

  protected readonly title = signal('aira');

  public zoomStyles = computed(() => {
    const size = this.zoomService.fontSize();
    // Calcular el scale relativo al tamaño base (16px)
    const scale = size / 16;
    return {
      transform: `scale(${scale})`,
      'transform-origin': 'top left',
      width: `min(100vw, calc(100vw / ${scale}))`,
      height: `min(100vh, calc(100vh / ${scale}))`,
    };
  });

  private zoomService = inject(ZoomService);
  private themeService = inject(ThemeService);
  public inactivityTimerService = inject(InactivityTimerService);
  public authState = inject(AuthStateService);

  ngOnInit(): void {
    this.themeService.loadUserThemePreference();
  }
}
